import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { summariseAssetTasks } from "routes/asset-register/plugins/regime-display/controller/summarise-asset-tasks"
import { Divider, Skeleton, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ListItemBox } from "lib/@components/ListItemBox"
import { formatTime } from "lib/format-time"
import { periodIntervalHoursFromTask } from "library/period-interval-hours-from-task.mjs"
import { convertPeriodLabelToFrequency } from "library/convert-period-label-to-frequency.mjs"
import { normalisePeriod } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/period/normalise-period"
import { PeriodEntry } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/period/period-entry"
import { dummyResult } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/skills/dummy-result"

export function PeriodSummaries() {
    const { regimeId, group, filters, search } = useBoundContext()
    const summary =
        summariseAssetTasks.useResults({
            regimeId,
            group,
            filters,
            search,
            summarise: ["frequency.label"],
        }) ?? dummyResult
    const results = Object.fromEntries(
        Object.entries(summary.groupBy((c) => normalisePeriod(c.value[0]))).map(([key, list]) => [
            key,
            {
                count: list.sum("count"),
                minutes: list.sum("minutes"),
            },
        ])
    )

    const totalMinutes = summary.sum("minutes")
    const totalTasks = summary.sum("count")

    return summary === dummyResult ? (
        <Skeleton animation="wave" sx={{ m: 2 }} variant="rounded" height={120} />
    ) : (
        <>
            <Stack direction="row" justifyContent="flex-start" flexWrap="wrap" sx={{ p: 2 }}>
                <Repeat
                    list={Object.keys(results).sortBy((label) =>
                        periodIntervalHoursFromTask({ frequency: convertPeriodLabelToFrequency(label) })
                    )}
                    item={<PeriodEntry results={results} totalMinutes={totalMinutes} />}
                />
            </Stack>
            <Divider />
            <ListItemBox px={2} py={0.5}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold" }}>
                    {formatTime(totalMinutes)} per annum for {totalTasks.toLocaleString()}{" "}
                    {"task".pluralize(totalTasks)}
                </Typography>
            </ListItemBox>
        </>
    )
}
